module.exports = __webpack_public_path__ + "static/dbd-Rond-NightblueBlauw-1832f7e555c3155d7c70186008967cca.jpeg";